import React from "react";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
const needs = ["A case.", "A framework.", "A structured procedure sequence.", "Focused questions.", "A way to extract what you learned."];
const perks = ["6 Premium Volumes + 5 Bonuses", "Instant digital access", "Lifetime access", "7-day guarantee"];
export function FinalCTA() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-188" data-mp="3dsaml0x7yvig">
      <div className="mx-auto max-w-2xl text-center" data-id="element-189" data-mp="3hufb5l8t91y8">
        <h2 className="text-balance font-serif text-3xl font-bold leading-tight sm:text-5xl" data-id="element-190" data-mp="3hw0arp9zfb2y">
          Ready to stop studying mastopexy in pieces… <em className="text-goldlight" data-id="element-191" data-mp="38tqxwsr8r5me">and start reviewing it with a system?</em>
        </h2>
        <p className="mt-6 text-[17px] text-white/75" data-id="element-192" data-mp="123suq9tl0o4j">You don't need another 20-hour lecture. You need:</p>

        <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-193" data-mp="172dzmmjs3vzb">
          {needs.map(n => <li key={n} className="flex items-center gap-3 text-[17px] font-semibold" data-id="element-194" data-mp="q83px7iq8llh">
              <CheckIcon className="h-5 w-5 shrink-0 text-goldlight" strokeWidth={3} aria-hidden="true" data-id="element-195" data-mp="l9k5xcnp1jvr" />
              {n}
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl bg-white p-6 text-ink sm:p-8" data-id="element-196" data-mp="z05mgupodhqh">
          <p className="text-sm font-bold uppercase tracking-wide text-ink/60" data-id="element-197" data-mp="v0n343di5epr">Mastopexy Surgical Blueprint™</p>
          <p className="mt-1 flex items-baseline justify-center gap-3" data-id="element-198" data-mp="7aaxiz5qbu2c">
            <s className="text-2xl font-bold text-ink/40" data-id="element-199" data-mp="2bg7pd9ch58q">$294</s>
            <span className="font-serif text-7xl font-extrabold text-cta" data-id="element-200" data-mp="gafvyjsy3i4d">$27</span>
            <span className="text-sm font-bold text-ink/60" data-id="element-201" data-mp="g8cwza9teeni">USD</span>
          </p>
          <ul className="mx-auto mt-4 grid max-w-sm gap-1.5 text-left sm:grid-cols-2" data-id="element-202" data-mp="ba1j8ogefk00">
            {perks.map(p => <li key={p} className="flex items-start gap-2 text-[15px] font-medium" data-id="element-203" data-mp="1rrflx8rtlkv8">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-204" data-mp="1msm4j59ex9ps" />
                {p}
              </li>)}
          </ul>
          <div className="mt-6" data-id="element-205" data-mp="pavlraqw2kp6">
            <CTAButton label="Get Mastopexy Surgical Blueprint™" note="One-time payment of $27 USD · Automatic currency conversion · Instant digital access · 7-day guarantee" data-id="element-206" data-mp="pe184i84v8h7" />
          </div>
          <Countdown data-id="element-207" data-mp="1n5inrr5gpd4" />
        </div>
      </div>
    </section>;
}